export default __webpack_public_path__ + "static/fonts/ABCDiatypeRounded-Regular_4cgGIc.woff2";